import { styled } from 'styled-components';
import { theme } from '../../templates/ui';

export const CardWrapper = styled.div`
  position: relative;
  margin-left: ${theme.sizing.small};
`;
